import ChatBodyFooterEditing from "./ChatBodyFooterEditing";

export default ChatBodyFooterEditing;
